import * as React from "react";
import * as R from "ramda";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { connect } from "react-redux";
import { DotLoader } from "react-spinners";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { Form } from "react-final-form";
import TiposTransacciones from "../../../general/componentes/TiposTransacciones";
import DatePickerSura from "../../../general/componentes/DatePicker";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DatosMasivoGlosa, DatosGenerarFtp } from "../modelo/EnvioMasivoGlosas";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import {
    enviarGlosasConCodigo,
    enviarMasivoGlosas,
    descargarPlantillaMasivoGlosas,
    limpiarMensajesMasivoGlosas,
    generarArchivoFtp
} from "../modulos/procesarMasivoGlosasActions";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { 
    fechaInicialBusqueda,
    fechaFinalBusqueda, 
    servicioGestion, 
    glosaGestion,
    glosasGestion,
    estadosProceso
} from "../../config_general/modelo/TextosAyuda";
import ModalAyudaVentana from "../../config_general/componentes/ModalAyudaVentana";
import { tituloVentanaCargaRetiro } from "../../config_general/modelo/TextoVentanaAyuda";
import { consultarMaestroTransaccionesSat, consultarCatalogoGlosasSat } from "../../../general/modulos/maestrosActions";
import * as moment from "moment";
import { EstadoGlosa } from "../modelo/EstadoGlosa";


class EstructuraEnvioMasivoGlosas extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.renderEstadoEnvioIndividual = this.renderEstadoEnvioIndividual.bind(this);
        this.renderEstadoEnvioMasivo = this.renderEstadoEnvioMasivo.bind(this);
        this.renderPestañaEstadoCarga = this.renderPestañaEstadoCarga.bind(this);
        this.validarXLS = this.validarXLS.bind(this);

        this.state = {
            ventanaAyuda: false,
            fileUpload: React.createRef(),
            archivo: null,
            archivoCorrecto: false,
            estadoCarga: REQUEST.NONE
        };
    }

    componentWillMount() {
        if (!this.props.transaccionesSat || this.props.transaccionesSat.length === 0) {
            this.props.dispatch(consultarMaestroTransaccionesSat());
        }
    }

    componentDidMount() {
        if (!this.props.catalogoGlosasSat || this.props.catalogoGlosasSat.length === 0) {
            this.props.dispatch(consultarCatalogoGlosasSat());
        }
    }

    componentWillUnmount() {
        this.props.dispatch(limpiarMensajesMasivoGlosas());
    }

    render() {
        const { estadoEnvioMasivo, estadoEnvioIndividual, mensajeUsuario, registrosEncontrados } = this.props;

        return (
            <div>
                <Row>
                    {this.crearVentanaAyuda()}
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Envió Masivo y Generar Archivo Consulta de Glosas
                                    <button type="button" className="btns btns-glyphicon" onClick={this.actualizarModalAyuda}
                                        disabled={this.state.ventanaAyuda}>
                                        <span className="icons-table">
                                            <Glyphicon style={{ left: `10px` }} glyph="question-sign" />
                                        </span>
                                    </button>
                                </h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Envió masivo por glosa</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={2}>
                                                <label>Código Glosa</label>
                                                <TextoAyuda texto={glosaGestion} />
                                                <TextoInputSelector name="codigoGlosa" maestro={this.listaCatalogoGlosasSat()} />
                                                {errors.codigoGlosa &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.codigoGlosa}</span>
                                                    </div>
                                                }
                                            </Col>
                                            <Col sm={3}>
                                                <label>Servicio Envió</label>
                                                <TextoAyuda texto={servicioGestion} />
                                                <TiposTransacciones name={"servicio"} gestionables />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="fechaRetiro">Fecha Inicial</label>
                                                <TextoAyuda texto={fechaInicialBusqueda} />
                                                <DatePickerSura name={"fechaInicial"} fechaMaxima={moment()} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="fechaRetiro">Fecha Final</label>
                                                <TextoAyuda texto={fechaFinalBusqueda} />
                                                <DatePickerSura name={"fechaFinal"} fechaMaxima={moment()} />
                                            </Col>
                                        </Row>
                                        <Row className={"form-group"}>
                                            <Col smOffset={8} sm={1} style={{ marginTop: '20px' }}>
                                                <button type="button" className="btns btns-link" onClick={form.reset}
                                                    disabled={submitting || pristine}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={2}>
                                                <br />
                                                <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                    <b>Enviar Individual</b> &nbsp;<Glyphicon className={"glyphicon-play"} glyph={"glyphicon-play"} />
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <Row>
                                    {
                                        this.renderEstadoEnvioIndividual(estadoEnvioIndividual, mensajeUsuario, registrosEncontrados)
                                    }
                                </Row>
                                <br />
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Envió masivo archivo glosas</h3>
                                    </div>
                                    <div className={"card-body"} style={{ marginTop: '30px' }}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <a className="btns btn-success" onClick={this.descargarPlantillaXLS} >
                                                    <b>Plantilla Excel</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                </a>
                                            </Col>
                                            <Col sm={3}>
                                                <a className="btns btn-primary" onClick={this.cargarArchivoXLS} >
                                                    <input type="file" ref={this.state.fileUpload} name="archivo"
                                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style={{ display: "none" }} />
                                                    <b>Cargar Excel</b> &nbsp;<Glyphicon className={"upload"} glyph={"upload"} />
                                                </a>
                                            </Col>
                                            <Col smOffset={2} sm={1}>
                                                <button type="button" className="btns btns-link" onClick={this.resetFile}
                                                    disabled={!this.state.archivoCorrecto}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={2}>
                                                <button className="btns btns-primary" style={{ width: '142px' }} onClick={this.enviarMasivo} disabled={!this.state.archivoCorrecto}>
                                                    <b>Enviar Masivo</b> &nbsp;<Glyphicon className={"glyphicon-play"} glyph={"glyphicon-play"} />
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <Row>
                                    {this.renderPestañaEstadoCarga()}
                                    {this.renderEstadoEnvioMasivo(estadoEnvioMasivo, mensajeUsuario)}
                                </Row>
                            </form>
                        )}
                    />
                </Row>
                <br />
                <Row>
                    <Form
                        onSubmit={this.onSubmitGenerarArchivo}
                        validate={this.validateGenerarArchivo}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Generar consulta FTP</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={11}>
                                                <label>Códigos Glosa</label>
                                                <TextoAyuda texto={glosasGestion} />
                                                <TextoInputSelector name="codigosGlosa" selectorMultiple maestro={this.listaCatalogoGlosasSat()} />
                                                {errors.codigosGlosa &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.codigosGlosa}</span>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className={"form-group"}>
                                            <Col sm={11}>
                                                <label>Estados</label>
                                                <TextoAyuda texto={estadosProceso} />
                                                <TextoInputSelector name="estados" selectorMultiple maestro={this.listaEstadosEnvioSat()} />
                                                {errors.estados &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.estados}</span>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className={"form-group"}>
                                            <Col sm={2}>
                                                <label>Servicio Envió</label>
                                                <TextoAyuda texto={servicioGestion} />
                                                <TiposTransacciones name={"servicio"} gestionables />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="fechaRetiro">Fecha Inicial</label>
                                                <TextoAyuda texto={fechaInicialBusqueda} />
                                                <DatePickerSura name={"fechaInicial"} fechaMaxima={moment()} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="fechaRetiro">Fecha Final</label>
                                                <TextoAyuda texto={fechaFinalBusqueda} />
                                                <DatePickerSura name={"fechaFinal"} fechaMaxima={moment()} />
                                            </Col>
                                            <Col sm={1} style={{ marginTop: '20px' }}>
                                                <button type="button" className="btns btns-link" onClick={form.reset}
                                                    disabled={submitting || pristine}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={2}>
                                                <br />
                                                <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                    <b>Generar Archivo</b> &nbsp;<Glyphicon className={"glyphicon-play"} glyph={"glyphicon-play"} />
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <Row>
                                    {
                                        this.renderEstadoGenerarFtp()
                                    }
                                </Row>
                            </form>
                        )}
                    />
                </Row>
            </div>
        );
    }

    renderEstadoEnvioIndividual(estadoEnvioIndividual: REQUEST, mensajeUsuario: string, registrosEncontrados: number) {
        switch (estadoEnvioIndividual) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"}
                            mensaje={` Se realizó la carga de la información exitosamente. Se encuentra en proceso de envío ${registrosEncontrados} registros.`}
                        />
                    </span>
                );
            default:
                return false;
        }
    }

    renderPestañaEstadoCarga() {
        switch (this.state.estadoCarga) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={" El archivo no se cargó porque no cumple con el formato o el tamaño de 1 Megabytes."} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"} mensaje={" El archivo se cargó con éxito. Se debe dar clic en Enviar Masivo para realizar el envió."} />
                    </span>
                );
            default:
                return false;
        }
    }

    renderEstadoEnvioMasivo(estadoEnvioMasivo: REQUEST, mensajeUsuario: string) {
        switch (estadoEnvioMasivo) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"}
                            mensaje="Se realizó la carga de la información exitosamente esta se encuentra en proceso de envío."
                        />
                    </span>
                );
            default:
                return false;
        }
    }

    renderEstadoGenerarFtp() {
        const { estadoGenerarArchivo, registrosEncontrados, correos, mensajeUsuario } = this.props;

        switch (estadoGenerarArchivo) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"}
                            mensaje={`Se realizó la consulta con éxito y se encontraron ${registrosEncontrados} registros con los filtros seleccionados.
                            Se enviará un correo a los destinatarios ${correos} al terminar el proceso de creación del archivo en el FTP.`}
                        />
                    </span>
                );
            default:
                return false;
        }
    }

    crearVentanaAyuda = () => {
        return (
            <ModalAyudaVentana
                titulo={tituloVentanaCargaRetiro}
                visible={this.state.ventanaAyuda}
                onCancelar={this.actualizarModalAyuda}
            >
                <p style={{ color: "#000000" }}>Por medio de esta ventana podrás enviar a SAT de forma individual o masiva las inconsistencias para su gestion
                    de las siguientes formas:
                    <br />
                    <br />
                    <strong>Individual: </strong>Ingresando los datos de envió individual y dando clic en el botón Enviar individual.
                    <br />
                    <br />
                    <strong>Masivo: </strong>Descargar la plantilla de Excel, diligenciar los datos en esta de las inconsistencias a gestionar y se respectivo proceso, guardar los cambios,
                    luego con el botón de cargar Excel se busca el documento con el nombre que se guardó y se selecciona, por último se da clic en el botón Enviar Masivo.
                </p>
            </ModalAyudaVentana >
        );
    }

    actualizarModalAyuda = () => {
        this.setState({ ventanaAyuda: !this.state.ventanaAyuda });
    }

    validate = (values: any) => {
        const errors = {
            servicio: undefined,
            codigoGlosa: undefined,
            fechaInicial: undefined,
            fechaFinal: undefined
        };

        if (!values.codigoGlosa)
            errors.codigoGlosa = "Por favor seleccione la glosa";

        if (values.codigoGlosa && !values.servicio)
            errors.servicio = "Por favor seleccione el servicio";

        if (values.servicio && values.codigoGlosa && !values.fechaInicial)
            errors.fechaInicial = "Por favor seleccione la fecha inicial";

        if (values.servicio && values.codigoGlosa && values.fechaInicial && !values.fechaFinal)
            errors.fechaFinal = "Por favor seleccione la fecha final";

        if (values.fechaInicial && values.fechaFinal && values.fechaInicial.isAfter(values.fechaFinal)) {
            errors.fechaFinal = "La fecha final no puede ser anterior a la fecha inicial";
        }

        return errors;
    };

    validateGenerarArchivo = (values: any) => {
        const errors = {
            servicio: undefined,
            codigosGlosa: undefined,
            fechaInicial: undefined,
            fechaFinal: undefined,
            estados: undefined
        };

        const contieneGlosa = values.codigosGlosa && values.codigosGlosa.length > 0;
        const contieneEstado = values.estados && values.estados.length > 0;


        if (!contieneGlosa)
            errors.codigosGlosa = "Por favor seleccione al menos una glosa";

        if (contieneGlosa && !contieneEstado)
            errors.estados = "Por favor seleccione al menos un estado del proceso";

        if (contieneGlosa && contieneEstado && !values.servicio)
            errors.servicio = "Por favor seleccione el servicio";

        if (contieneGlosa && contieneEstado && values.servicio && !values.fechaInicial)
            errors.fechaInicial = "Por favor seleccione la fecha inicial";

        if (contieneGlosa && contieneEstado && values.servicio && values.fechaInicial && !values.fechaFinal)
            errors.fechaFinal = "Por favor seleccione la fecha final";

        if (values.fechaInicial && values.fechaFinal && values.fechaInicial.isAfter(values.fechaFinal)) {
            errors.fechaFinal = "La fecha final no puede ser anterior a la fecha inicial";
        }

        return errors;
    };

    onSubmit = (values: any) => {
        const servicio = values.servicio ? Number(values.servicio) : undefined;
        const codigoGlosa = values.codigoGlosa ? values.codigoGlosa.value : undefined;
        const fechaInicial = values.fechaInicial ? values.fechaInicial.format("YYYY-MM-DD").valueOf() : "";
        const fechaFinal = values.fechaFinal ? values.fechaFinal.format("YYYY-MM-DD").valueOf() : "";

        const datosMasivoGlosa: DatosMasivoGlosa = {
            servicio: servicio,
            codigoGlosa: codigoGlosa,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            dniUsuarioOperacion: this.props.dniUsuarioGestionLogin
        };
        this.props.dispatch(enviarGlosasConCodigo(datosMasivoGlosa));
    };

    onSubmitGenerarArchivo = (values: any) => {
        const servicio = values.servicio ? Number(values.servicio) : undefined;
        const fechaInicial = values.fechaInicial ? values.fechaInicial.format("YYYY-MM-DD").valueOf() : "";
        const fechaFinal = values.fechaFinal ? values.fechaFinal.format("YYYY-MM-DD").valueOf() : "";
        let codigosGlosa = undefined;
        let estados = undefined;

        if (values.codigosGlosa) codigosGlosa = values.codigosGlosa.map(glosa => glosa.value);
        if (values.estados) estados = values.estados.map(estado => estado.value);

        const datosGenerarFtp: DatosGenerarFtp = {
            servicio: servicio,
            codigosGlosa: codigosGlosa,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            estadosGlosa: estados,
            dniUsuarioOperacion: this.props.dniUsuarioGestionLogin
        };
        this.props.dispatch(generarArchivoFtp(datosGenerarFtp));
    };

    enviarMasivo = () => {
        if (this.state.archivoCorrecto) {
            this.props.dispatch(enviarMasivoGlosas(this.state.archivo));
        }
        this.resetFile();
    }

    descargarPlantillaXLS = () => {
        this.props.dispatch(descargarPlantillaMasivoGlosas());
    }

    resetFile = () => {
        this.setState({
            estadoCarga: REQUEST.NONE,
            archivo: null,
            archivoCorrecto: false
        });
    }

    cargarArchivoXLS = () => {
        const fileUpload = this.state.fileUpload.current;
        fileUpload.value = null;
        fileUpload.click();
        fileUpload.onchange = (e) => {
            this.validarXLS(e.target.files[0]);
        };
    }

    validarXLS(file: File) {
        if (file) {
            const nombre = file.name;
            const extencion = nombre.substring(nombre.length - 4, nombre.length);
            const tamano = file.size;
            if (extencion !== "xlsx" || tamano > 1000000) {
                this.setState({
                    estadoCarga: REQUEST.ERROR,
                    archivo: null,
                    archivoCorrecto: false
                });
                return;
            }
            this.setState({
                estadoCarga: REQUEST.SUCCESS,
                archivo: file,
                archivoCorrecto: true
            });
        }
    }

    listaCatalogoGlosasSat = () => {
        if (this.props.catalogoGlosasSat && this.props.catalogoGlosasSat.length > 0) {
            return this.props.catalogoGlosasSat.map(value => ({
                value: value.codigoGlosa,
                label: value.codigoGlosa
            }));
        }
        return [{ value: '', label: 'Cargando...' }];
    }

    listaEstadosEnvioSat = () => {
        if (EstadoGlosa) {
            return EstadoGlosa.map(estadoGlosa => ({
                value: estadoGlosa.estado,
                label: estadoGlosa.nombre
            }));
        }
        return [{ value: '', label: 'Cargando...' }];
    }
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        estadoEnvioIndividual: R.pathOr([], ["envio_masivo_glosas", "estadoEnvioIndividual"])(store),
        estadoEnvioMasivo: R.pathOr([], ["envio_masivo_glosas", "estadoEnvioMasivo"])(store),
        estadoGenerarArchivo: R.pathOr([], ["envio_masivo_glosas", "estadoGenerarArchivo"])(store),
        mensajeUsuario: R.pathOr(undefined, ["envio_masivo_glosas", "mensajeUsuario"])(store),
        registrosEncontrados: R.pathOr(undefined, ["envio_masivo_glosas", "registrosEncontrados"])(store),
        registrosParametro: R.pathOr(undefined, ["envio_masivo_glosas", "registrosParametro"])(store),
        correos: R.pathOr(undefined, ["envio_masivo_glosas", "correos"])(store),
        transaccionesSat: R.pathOr([], ["maestros", "transaccionesSat"])(store),
        catalogoGlosasSat: R.pathOr([], ["maestros", "catalogoGlosasSat"])(store)
    };
})(EstructuraEnvioMasivoGlosas);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_masivo_glosas/componentes/EstructuraEnvioMasivoGlosas.tsx